import React from "react"
import Paper from "material-ui/Paper"
import Tabs from "material-ui/Tabs"
import Tab from "material-ui/Tabs/Tab"
import strings from "../../../localization/strings"
import { browserHistory } from "react-router"
import EquipmentTimecard from "../../../components/timecard/EquipmentTimecard"
import AccountStore from "../../../stores/AccountStore"
import EquipmentHistory from "./EquipmentHistory"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import * as permissionHelper from "../../../helpers/permissionHelper"

interface IProps {
    equipmentId: string
    subpage: string
    readonly: boolean
    timecardReadonly: boolean
}

const UserDetailsData: React.SFC<IProps> = (props: IProps) => {
    return (
        <div className="EquipmentDetailsData">
            <Paper zDepth={1} style={{ textAlign: "left", margin: 20, marginTop: 20 }}>
                <Tabs value={props.subpage} onChange={(value) => browserHistory.push("/equipment-details/" + props.equipmentId + "/" + value)}>
                    {AccountStore.getTimecardEnabled() &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ViewTimecards) &&
                        <Tab label="timecards" value="timecards">
                            {props.subpage === "timecards" &&
                                <EquipmentTimecard equipmentId={props.equipmentId} readonly={props.timecardReadonly} />
                            }
                        </Tab>
                    }
                    <Tab label={strings.History} value="history">
                        {props.subpage === "history" &&
                            <div className="equipment-detail-tab">
                                <EquipmentHistory />
                            </div>
                        }
                    </Tab>
                </Tabs>
            </Paper>
        </div>
    )
}

export default UserDetailsData
